{#each Array(3) as _}
  <li>
    <div
      class="flex w-52 animate-pulse flex-col items-center gap-3 rounded-xl bg-white p-4"
      role="status"
      aria-label="Loading media card"
    >
      <div class="h-32 w-full rounded-lg bg-neutral-200" />

      <div class="flex w-full flex-col text-left">
        <div class="mb-1 h-4 w-3/4 rounded bg-neutral-200" />
        <div class="h-3 w-1/2 rounded bg-neutral-200" />
      </div>

      <div class="flex h-9 w-full rounded-lg bg-neutral-200" aria-hidden="true" />
    </div>
  </li>
{/each}
